import { Collapse } from '@any-ui-react/core';
import { TrBody } from '@any-ui-react/table';
import type { PropsWithChildren } from 'react';

interface TableCollapseRowProps {
  colSpan: number;
  isOpen: boolean;
}

export const TableCollapseRow = ({ colSpan, children, isOpen }: PropsWithChildren<TableCollapseRowProps>) => (
  <TrBody className="h-fit border-t-0 border-none">
    <td className="p-0" colSpan={colSpan}>
      <Collapse in={isOpen}>{children}</Collapse>
    </td>
  </TrBody>
);
